export const overviewDatasets = [
  { id: "dataset-a", name: "人物专属数据库A" },
  { id: "dataset-b", name: "混合数据库B" },
  { id: "dataset-c", name: "数据库C" },
];

export const datasetRecords = [
  {
    id: "dataset-a",
    name: "人物专属数据库A",
    description: "人物类文章样本集，覆盖知名人物、机构人物相关报道。",
    source: "多科信息库",
    host: "https://data.multiinfo.com",
    port: "3306",
    dbName: "person_db",
    account: "sky123456",
    articleCount: 4820,
    saveType: "数据库导入",
    createTime: "2026/8/12",
    status: 1,
  },
  {
    id: "dataset-b",
    name: "混合数据库B",
    description: "政治、经济、文化多领域混合文章样本集。",
    source: "公开新闻库",
    host: "https://data.opennews.cn",
    port: "3306",
    dbName: "mixed_db",
    account: "news_reader",
    articleCount: 3120,
    saveType: "数据库导入",
    createTime: "2026/8/15",
    status: 1,
  },
  {
    id: "dataset-c",
    name: "数据库C",
    description: "生态环保主题文章样本集，含地名与机构名称。",
    source: "地方媒体库",
    host: "https://data.localmedia.org",
    port: "3306",
    dbName: "eco_db",
    account: "eco_admin",
    articleCount: 1980,
    saveType: "数据库导入",
    createTime: "2026/8/19",
    status: 0,
  },
];

export const datasetSampleArticles = [
  {
    id: "s1",
    title: "高效统筹疫情防控与经济社会发展",
    source: "人民日报",
    date: "2026/8/4",
    words: 3500,
    score: 1.5,
  },
  {
    id: "s2",
    title: "多地出台稳经济一揽子政策 助力企业纾困",
    source: "经济日报",
    date: "2026/8/6",
    words: 2860,
    score: 1.3,
  },
  {
    id: "s3",
    title: "绿色发展成为区域经济增长新引擎",
    source: "新华网",
    date: "2026/8/9",
    words: 3120,
    score: 1.1,
  },
  {
    id: "s4",
    title: "文化和旅游融合发展释放消费新活力",
    source: "光明日报",
    date: "2026/8/11",
    words: 2410,
    score: 0.9,
  },
];